import React, { createContext, useContext, useMemo } from 'react';
import { ThemeProvider, createTheme, responsiveFontSizes, Theme } from '@mui/material/styles';
import { DomainConfig, getDomainConfig } from './domainConfig';

interface ThemeContextType {
  activeDomainConfig: DomainConfig;
  theme: Theme;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeContext must be used within a ThemeContextProvider');
  }
  return context;
};

interface ThemeContextProviderProps {
  children: React.ReactNode;
}

export const ThemeContextProvider: React.FC<ThemeContextProviderProps> = ({ children }) => {
  const hostname = window.location.hostname;
  
  const activeDomainConfig = useMemo(() => {
    return getDomainConfig(hostname);
  }, [hostname]);

  const theme = useMemo(() => {
    let t = createTheme(activeDomainConfig.themeOptions);
    t = responsiveFontSizes(t);
    return t;
  }, [activeDomainConfig]);

  return (
    <ThemeContext.Provider value={{ activeDomainConfig, theme }}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};
